var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37886 2.30984C9.63848 1.7173 10.4791 1.71729 10.7387 2.30984L12.4885 6.30346C12.5962 6.54924 12.8281 6.71778 13.0952 6.74424L17.434 7.1743C18.0778 7.23811 18.3376 8.03755 17.8543 8.46757L14.5968 11.3658C14.3963 11.5442 14.3077 11.8169 14.3651 12.079L15.2969 16.3384C15.4351 16.9704 14.7551 17.4645 14.1967 17.1377L10.4337 14.9353C10.2021 14.7998 9.91541 14.7998 9.68381 14.9353L5.92081 17.1377C5.36248 17.4645 4.68244 16.9704 4.82069 16.3384L5.75246 12.079C5.80981 11.8169 5.72121 11.5442 5.52073 11.3658L2.26329 8.46757C1.77997 8.03755 2.03973 7.23811 2.6835 7.1743L7.02237 6.74424C7.28941 6.71778 7.52137 6.54925 7.62906 6.30346L9.37886 2.30984Z",
    fill: "#EFA617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4fca475794259cfe7ae7c05cb169b62d.svg";
export { ForwardRef as ReactComponent };